module.exports = __webpack_public_path__ + "static/media/YB5F01_5.69540b70.jpg";